module.exports = __webpack_public_path__ + "media/images/icon_new-407e9ed8d0f1cc3c03c24b39c40e0850.svg";